import React from 'react';
import NavbarLogo from '../../assets/TmsLogoh.png';
import TMSLogo from '../../assets/TMSLogo.png';

/**
 * Logo Component
 * 
 * Centralizes logo rendering to ensure consistency and easier maintenance.
 * 
 * @param {Object} props
 * @param {string} props.className - Additional CSS classes
 * @param {Object} props.style - Inline styles
 * @param {string} props.variant - Predefined size variant: 'sidebar', 'auth', 'compact', 'full'
 * @param {number|string} props.maxWidth - Manual override for maximum width
 * @param {boolean} props.useTMS - Whether to use the TMSLogo.png instead of Navbar logo
 */
const Logo = ({ className = '', style = {}, variant = 'full', maxWidth, useTMS }) => {
    // Best practice sizing based on context
    const getVariants = () => {
        switch (variant) {
            case 'sidebar':
                return { maxWidth: '13.125rem', padding: '0.125rem 0 0.25rem 0' }; // 210px, 2px 4px
            case 'auth':
                return { maxWidth: '28.125rem', marginBottom: '0.75rem' }; // 450px, 12px
            case 'compact':
                return { maxWidth: '2rem', padding: '0.3125rem' }; // 32px, 5px
            default:
                return { maxWidth: '11.25rem', margin: '0.3125rem 0' }; // 180px, 5px
        }
    };

    const variantStyle = getVariants();
    const combinedStyle = {
        ...variantStyle,
        maxWidth: maxWidth || variantStyle.maxWidth,
        height: 'auto',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        objectFit: 'contain',
        transition: 'all 0.3s ease',
        ...style
    };

    // Use TMSLogo if specifically requested OR if it's the auth variant
    const logoSource = (useTMS || variant === 'auth') ? TMSLogo : NavbarLogo;

    return (
        <img
            src={logoSource}
            alt="BFRET Logo"
            className={`img-fluid logo-component ${className}`}
            style={combinedStyle}
        />
    );
};

export default Logo;
